import { Dialog, DialogActions, DialogContent, DialogTitle, Divider, FormControlLabel, MenuItem, Switch } from '@mui/material';
import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import TextField from '@mui/material/TextField';
import { useFormik } from 'formik';
import { useEffect } from 'react';
import Address from '../../../../components/Address';
import useDialog from '../../../../hooks/useDialog';
import useErrors from '../../../../hooks/useErrors';
import { useFetch } from '../../../../hooks/useFecth';
import server from '../../../../services/server';
import PhoneInputMasked from '../../../../components/PhoneInputMasked';
import DocumentInputMasked from '../../../../components/DocumentInputMasked';

function Edit({ id, mutate }) {
    const { data } = useFetch(`clubs/${id}`);
    data.owner = data?.UsersFactory.find(user => user?.role === 'owner');
 
    console.log(data.owner)
 
    return <Form data={data} mutate={mutate} />;
}

function Form({ data, mutate }) {
    const { open, handleClose } = useDialog('#clubs');
    const { setErrors, enqueueSnackbar } = useErrors();

    const { values, handleSubmit, handleChange, errors, setFieldValue, setFieldError, setValues, isSubmitting } = useFormik({
        initialValues: {
            name: '',
            demo: false,
            description: '',
            document: '',
            businessName: '',
            zipcode: '',
            street: '',
            number: '',
            complement: '',
            neighborhood: '',
            city: '',
            goias: '',
            country: 'BR',
            supportPhone: '',
            supportEmail: '',
            customTelemedicineUrl: '',
            customTelepetUrl: '',
            customTelepsychologyUrl: '',
            status: '',
            responsibleName: '',
            responsibleEmail: '',
            responsibleDocument: '',
            responsibleBirthday: '',
            responsibleGender: '',
            responsiblePhone: '',
            // domain: '',
            // packageName: '',
            // appIntent: '',
            // primaryColor: '',
            // secundaryColor: '',
            // planId: '',
        },
        onSubmit: async (values, { setSubmitting }) => {
            try {
                if (!Boolean(values.id)) {
                    setSubmitting(true);
                    await server.post(`clubs`, values);
                    enqueueSnackbar(`Clube ${values.name} adicionado`);
                }

                if (Boolean(values.id)) {
                    setSubmitting(true);
                    await server.put(`clubs/${values.id}`, values);
                    enqueueSnackbar(`Clube ${values.name} alterado`);
                }

                await mutate();
                setSubmitting(false);
                handleClose();
            } catch (error) {
                setSubmitting(false);
                setErrors(error);
            }
        },
    });

    useEffect(() => {
        if (data) {
            const {
                id,
                name,
                status,
                description,
                businessName,
                document,
                zipcode,
                street,
                number,
                complement,
                neighborhood,
                city,
                state,
                country,
                ClubCategory,
                responsibleName,
                responsibleEmail,
                responsibleDocument,
                responsibleGender,
                responsibleBirthday,
                responsiblePhone,
                supportEmail,
                supportPhone,
                customTelemedicineUrl,
                customTelepetUrl,
                customTelepsychologyUrl,
            } = data;

            console.log('data received:', { responsibleGender, responsibleName, responsibleEmail });

            const formattedBirthday = responsibleBirthday  ? new Date(responsibleBirthday).toLocaleDateString('en-CA') : null;

            setValues(
                {
                    id,
                    name,
                    status,
                    description,
                    businessName,
                    document,
                    zipcode,
                    street,
                    number,
                    complement,
                    neighborhood,
                    city,
                    state,
                    country,
                    address: `${street}, ${neighborhood}, ${city}-${state}`,
                    categoryId: ClubCategory?.map(i => i.categoryId) || [],
                    supportPhone,
                    supportEmail,
                    customTelemedicineUrl: customTelemedicineUrl || '',
                    customTelepetUrl: customTelepetUrl || '',
                    customTelepsychologyUrl: customTelepsychologyUrl || '',
                    responsibleName: responsibleName || '',
                    responsibleEmail: responsibleEmail || '',
                    responsibleDocument: responsibleDocument || '',
                    responsibleGender: responsibleGender || '',
                    responsibleBirthday: formattedBirthday || '',
                    responsiblePhone: responsiblePhone || '',
                },
                true,
            );
        }
    }, [data, setValues]);

    return (
        <Dialog open={open} onClose={handleClose} fullWidth maxWidth="sm">
            <DialogTitle>Adicionando/editando clube</DialogTitle>
            <Divider />
            <DialogContent>
                <Stack gap={2}>
                    {/* {Boolean(values.id) && (
                        <>
                            <AddImage name='logo' onChange={setFieldValue} value={values.previewImage || values.logo} />
                        </>
                    )} */}

                    <TextField
                        label="Nome do responsável pelo clube"
                        onChange={handleChange}
                        placeholder="Nome do dono clube"
                        name="responsibleName"
                        value={values.responsibleName}
                    />

                    <TextField
                        label="Email do responsável pelo clube"
                        onChange={handleChange}
                        placeholder="Email do dono clube"
                        name="responsibleEmail"
                        value={values.responsibleEmail}
                    />

                    <TextField
                        label="Documento do responsável pelo clube"
                        onChange={event => {
                            setFieldValue('responsibleDocument', event.target?.value || undefined);
                        }}
                        placeholder="Documento do dono clube"
                        name="responsibleDocument"
                        value={values.responsibleDocument}
                        InputProps={{
                            inputComponent: DocumentInputMasked,
                        }}
                    />

                    <TextField
                        label="Gênero do responsável pelo clube"
                        onChange={e => setFieldValue('responsibleGender', e.target.value)}
                        name="responsibleGender"
                        value={values.responsibleGender || ''}
                        select
                        fullWidth
                        variant="outlined"
                        placeholder="Gênero do dono do Clube"
                    >
                        <MenuItem value="male">Masculino</MenuItem>
                        <MenuItem value="female">Feminino</MenuItem>
                    </TextField>

                    <TextField
                        required
                        label="Telefone do responsável pelo clube"
                        onChange={event => setFieldValue('responsiblePhone', event.target?.value || undefined)}
                        placeholder="Telefone do clube"
                        name="responsiblePhone"
                        value={values.responsiblePhone}
                        error={Boolean(errors.responsiblePhone)}
                        helperText={errors.responsiblePhone}
                        InputProps={{
                            inputComponent: PhoneInputMasked,
                        }}
                    />

                    <TextField
                        label="Aniversário do responsável pelo clube"
                        onChange={handleChange}
                        placeholder="Aniversário"
                        name="responsibleBirthday"
                        type="date"
                        InputLabelProps={{
                            shrink: true,
                        }}
                        value={values.responsibleBirthday}
                    />

                    <Divider />

                    <TextField label="Nome do clube" onChange={handleChange} placeholder="Nome do clube" name="name" value={values.name} />

                    {Boolean(values.id) && (
                        <>
                            <TextField
                                label="Razão Social"
                                onChange={handleChange}
                                placeholder="Razão social"
                                name="businessName"
                                value={values.businessName}
                            />

                            <TextField
                                label="Documento"
                                onChange={handleChange}
                                placeholder="Documento"
                                name="document"
                                value={values.document}
                                InputProps={{
                                    inputComponent: DocumentInputMasked,
                                }}
                            />
                            <Address
                                onChange={handleChange}
                                setFieldValue={setFieldValue}
                                name="zipcode"
                                setFieldError={setFieldError}
                                value={values.zipcode}
                                address={values.address}
                            />
                            <Stack direction="row" columnGap={2}>
                                <TextField fullWidth onChange={handleChange} label="Complemento" name="complement" value={values.complement} />
                                <TextField sx={{ width: 150 }} onChange={handleChange} label="Número" name="number" value={values.number} />
                            </Stack>

                            {/* <SelectCategories
                                value={values.categoryId}
                                name="categoryId"
                                onChange={setFieldValue}
                                label="Selecione as categorias"
                            /> */}

                            <TextField
                                required
                                label="Telefone para suporte"
                                onChange={event => setFieldValue('supportPhone', event.target?.value || undefined)}
                                placeholder="Telefone do clube"
                                name="supportPhone"
                                value={values.supportPhone}
                                error={Boolean(errors.supportPhone)} // Exibe o estado de erro
                                helperText={errors.supportPhone} // Mensagem de erro personalizada
                                InputProps={{
                                    inputComponent: PhoneInputMasked,
                                }}
                            />
                            <TextField
                                label="Email de suporte"
                                onChange={handleChange}
                                placeholder="E-mail de suporte"
                                name="supportEmail"
                                value={values.supportEmail}
                            />
                            <TextField
                                label="URL telemedicina personalizada"
                                onChange={handleChange}
                                placeholder="https://..."
                                name="customTelemedicineUrl"
                                value={values.customTelemedicineUrl}
                                helperText="Em branco = padrão Eurobem."
                            />
                            <TextField
                                label="URL telepet personalizada"
                                onChange={handleChange}
                                placeholder="https://..."
                                name="customTelepetUrl"
                                value={values.customTelepetUrl}
                                helperText="Em branco = padrão Eurobem."
                            />
                            <TextField
                                label="URL telepsicologia personalizada"
                                onChange={handleChange}
                                placeholder="https://..."
                                name="customTelepsychologyUrl"
                                value={values.customTelepsychologyUrl}
                                helperText="Em branco = padrão Eurobem/WhatsApp."
                            />
                        </>
                    )}

                    {Boolean(values.id) && (
                        <>
                            <FormControlLabel
                                control={<Switch checked={values.status} onChange={e => setFieldValue('status', e.target.checked)} />}
                                orientation="horizontal"
                                label="Status do clube"
                            />
                        </>
                    )}
                </Stack>
            </DialogContent>
            <Divider />
            <DialogActions>
                <Button variant="contained" type="submit" onClick={handleSubmit} loading={isSubmitting}>
                    Salvar e continuar
                </Button>
            </DialogActions>
        </Dialog>
    );
}

export default function DialogClubs({ mutate }) {
    const { open, id } = useDialog('#clubs');
    if (open && id) return <Edit id={id} mutate={mutate} />;
    if (open) return <Form mutate={mutate} />;
}
